<template>
  <div class="whs-detail-hotel-reviews">
    <div class="whs-detail-hotel-reviews-header">
      <div class="whs-detail-hotel-reviews-title">
        Отзывы об отеле
        <span class="review-total">Всего: {{reviews.length}}</span>
      </div>
      <div
        class="whs-list-rating-wrap"
        v-if="rating && rating.total"
        :class="classNameFromRating(rating.total)"
      >
        <div class="whs-list-rating__total">{{ rating.total }}</div>
        <div class="whs-list-rating__verbose">{{ rating.total_verbose }}</div>
      </div>
    </div>
    <div class="whs-detail-hotel-reviews-container">
      <div class="review" v-for="review in reviewsSlice" :key="review.id">
        <div class="review-header">
          <div class="review-author">{{ review.author }}</div>
          <div class="review-created">{{ dateToLocaleString(review.created) }}</div>
        </div>
        <div class="review-content">
          <div
            v-if="review.review_plus"
            class="review-review_plus whs-icon"
          >{{ review.review_plus }}</div>
          <div
            v-if="review.review_minus"
            class="review-review_minus whs-icon"
          >{{ review.review_minus }}</div>
        </div>
      </div>
    </div>
    <div
      v-if="!showAll"
      @click="openReviews()"
      class="whs-button-main"
      style="margin: 8px; width: unset;"
    >Показать еще отзывы ({{ reviews.length - 5 }})</div>
  </div>
</template>

<script>
export default {
  name: 'Reviews',
  props: {
    reviews: {
      type: Array,
      required: true
    },
    rating: {
      type: Object
    },
    openReviews: {
      type: Function
    },
    reviewsAreOpen: {
      type: Boolean
    }
  },
  computed: {
    reviewsSlice: {
      get() {
        return this.showAll
          ? this.reviews
          : this.reviews.filter((_, i) => i < 5);
      }
    },
    showAll: {
      get() {
        return this.reviewsAreOpen || this.reviews.length < 8;
      }
    }
  },
  methods: {
    classNameFromRating(rating) {
      const rate = parseInt(rating, 10);
      if (rate >= 9) return 'best';
      else if (rate >= 8) return 'better';
      else if (rate >= 7) return 'good';
    },
    dateToLocaleString(string) {
      const month = [
        'Январь',
        'Февраль',
        'Март',
        'Апрель',
        'Май',
        'Июнь',
        'Июль',
        'Август',
        'Сентябрь',
        'Октябрь',
        'Ноябрь',
        'Декабрь'
      ];
      const parsed = string.split('-');
      if (parsed.length === 3)
        return `${month[parseInt(parsed[1]) - 1]} ${parsed[0]}`;

      return string;
    }
  }
};
</script>

<style scoped>
.whs-detail-hotel-reviews {
  margin: 24px 0;
  background-color: #fff;
  border-radius: 4px;
  box-shadow: 0 0 1px var(--color-text-5), 0 0 8px var(--color-bg-dark);
  overflow: hidden;
}
.whs-detail-hotel-reviews-title {
  font-size: 24px;
  padding: 8px 18px;
}
.whs-detail-hotel-reviews-header {
  display: flex;
  justify-content: space-between;
  padding: 12px 0;
}
.whs-detail-hotel-reviews-container {
}
.review-container {
}
.review-total {
  background-color: var(--color-bg);
  padding: 0 8px;
  font-size: 16px;
  border-radius: 24px;
}
.review {
  display: flex;
  flex-wrap: wrap;
  padding: 8px 0;
  background-color: #fff;
  overflow: hidden;
  border-top: 1px solid var(--color-bg-dark);
}
.review-header {
  flex: 1 1;
  padding: 8px 18px;
}
.review-author {
  font-size: 18px;
  padding-bottom: 4px;
}
.review-created {
  font-size: 12px;
}
.review-content {
  flex: 4 4;
  background-color: #fff;
  padding: 4px;
}
.review-review_plus,
.review-review_minus {
  display: flex;
  font-weight: 500;
  padding: 4px;
}
.review-review_minus {
  font-weight: 400;
}
.review-review_plus:before,
.review-review_minus:before {
  content: '\f164';
  padding: 0 8px;
  width: unset;
  font-size: 18px;
  color: var(--color-bg-cold);
}
.review-review_minus:before {
  content: '\f165';
  color: var(--color-alt-5);
}

.whs-list-rating-wrap {
  display: flex;
  align-items: center;
  padding: 8px 18px;
}
.whs-list-rating__total {
  width: 28px;
  padding: 3px;
  margin-right: 4px;
  background-color: var(--color-bg);
  font-weight: 600;
  font-size: 16px;
  border-radius: 100%;
  text-align: center;
}
.best .whs-list-rating__total {
  background-color: var(--color-third);
  color: #fff;
}
.better .whs-list-rating__total {
  background-color: var(--color-bg-warm);
  color: #fff;
}
.good .whs-list-rating__total {
  background-color: var(--color-alt);
  color: #fff;
}
.whs-list-rating__verbose {
  font-size: 16px;
}
</style>